export const SPEAKERS_HAS_ERRED = 'SPEAKERS_HAS_ERRED';
export const SPEAKERS_IS_LOADING = 'SPEAKERS_IS_LOADING';
export const SPEAKERS_FETCHED_OK = 'SPEAKERS_FETCHED_OK';
export const FEATURED_SPEAKERS_FETCHED_OK = 'FEATURED_SPEAKERS_FETCHED_OK';
export const SPEAKERS_GET_SPEAKER = 'SPEAKERS_GET_SPEAKER';



// WEBPACK FOOTER //
// ./src/data/constants/speakers.js